import React from 'react'

const ContentIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" {...props} viewBox="0 0 24 24">
        <path d="M22.267 24H1.733A1.735 1.735 0 0 1 0 22.268V1.735C0 .778.778 0 1.733 0h20.534C23.222 0 24 .778 24 1.735v20.533c0 .955-.778 1.732-1.733 1.732zM22 22V6H2v16h20zM2 2v2h20V2H2zm2 5h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 3h8a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zm1 9h6v-7H5v7zm11-9.002h4a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-9.002a1 1 0 0 1 1-1zM17 19h2v-7.002h-2V19z"
              fillRule="evenodd"/>
    </svg>
)



export default ContentIcon


// WEBPACK FOOTER //
// ./src/components/_common/_icons/ContentIcon.js